import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import "../../../Assets/css/card.css";
import loaderGif from '../../../Assets/img/icons/Animation - 1718370478484.gif';
import { useQuantityContext } from '../../QuantityContext';
import { Link } from "react-router-dom";
import DefaultProfileBg from "../../../Assets/img/card/profilebg.png"
import { useUserDetailContext } from '../../UserDetailContext';
import { useCreateCardDetailContext } from '../../CreatecardDetailContext';
import { AllCardLayouts } from './Layouts2';
import Fab from '@mui/material/Fab';
import Nofavourites from "../../../Assets/img/No-favourite.svg"
import AddIcon from '@mui/icons-material/Add';
import { Box, IconButton } from '@mui/material';
import AllBusinessCardSkeleton from "../../LoadingSkeleton/AllBusinessCardSkeleton"
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { ReactComponent as StudentIcon } from '../../../Assets/img/icons/Student.svg';
import { ReactComponent as ProfessionalIcon } from '../../../Assets/img/icons/Professional-icon.svg';
import { ReactComponent as PersonalCardIcon } from '../../../Assets/img/icons/card Personal customize.svg';

const AllBusinessCard = () => {
    const apiKey = process.env.REACT_APP_API_KEY
    const { quantity, sortOrder, sortDateOrder, latestDateOrder } = useQuantityContext();
    const { AllCards, cardDetailsAll, cardStylesAll, cardContactsAll, cardSocialLinkWebsites, cards, setCards, userDetails, favoriteCards, setFavoriteCards } = useUserDetailContext();
    const objectId = localStorage.getItem("objectId");

    const navigate = useNavigate();
    const [chooseCategory, setchooseCategory] = useState(false);
    const [chooseCustomizeCategory, setChooseCustomizeCategory] = useState(false);
    const [OpenLightBoxForCategory, setOpenLightBoxForCategory] = useState(false);
    const [NewCardType, setNewCardType] = useState('');
    const [isVerifiedDialogOpen, setIsVerifiedDialogOpen] = useState(false);

    const { setOtherCards, setGroupCardDetails, groupCardDetails } = useUserDetailContext();

    const { setCardDetails, setCardStyles, setCardQrStyles, setContactStyles, setSocialLinks, setAttachDocs,
        setIsPersonalDetailsSaved, updateCardDetails, updateSocialLinks2, updateCardStyles, updateCardQrStyles, updateContactStyles, updateAttachDocsVal } = useCreateCardDetailContext();
    axios.defaults.baseURL = `${process.env.REACT_APP_BACKEND_URL}`;

    const [loading, setLoading] = useState(false);

    const handleCloseVerifiedDialog = () => {
        setIsVerifiedDialogOpen(false);
        setOpenLightBoxForCategory(false);
        setchooseCategory(false);
        setChooseCustomizeCategory(false);
    };

    const handleCardTypeClick = (category) => {
        // console.log("Category :", category);
        setNewCardType(category);
        updateCardDetails({ "CardType": category });
        updateCardStyles({ "CardType": category });
        if (category === "Customize_Personal") {
            updateCardStyles({ "layoutStyle": '2' }); //For Personal Card - Default Layout is 2
        }
        updateCardQrStyles({ "CardType": category });
        updateSocialLinks2({ "card_type": category });
        updateContactStyles({ "card_type": category, mobile_number: userDetails.phone, email: userDetails.email });
        updateAttachDocsVal({ fieldName: "card_name", value: category }); // It is Needed If CardType is GenZ itself
        setchooseCategory(false);
        setChooseCustomizeCategory(false);
        setIsPersonalDetailsSaved(false);
        navigate('/create-card', { state: { category: category } });
    };

    const handleCreateNewCard = () => {
        // setSelectedCategory('');
        setNewCardType('');
        // setOpenLightBoxForCategory(true);
        setchooseCategory(true);
    };

    useEffect(() => {
        // Trigger loading state when AllCards change
        setLoading(true);
        setTimeout(() => {
            setLoading(false);
        }, 2000);
    }, [AllCards]);

    // const handleCreateNewCard = () => {
    //     // if (displayProf || displayStud) {
    //     //     setIsVerifiedDialogOpen(true);
    //     // }
    //     // else {
    //     setSelectedCategory('');
    //     setNewCardType('');
    //     setOpenLightBoxForCategory(true);
    //     // }
    // }
    const todayDate = new Date();

    const [ContactStylesForGenZ, setContactStylesForGenZ] = useState({
        User_ID: objectId,
        CardType: 'GenZ',
        callNo: { input: `${userDetails.phone}`, visible: true },
        textNo: { input: `${userDetails.phone}`, visible: true },
        emailId: { input: `${userDetails.email}`, visible: true },
        whatsapp: { input: `${userDetails.phone}`, visible: true },
    });

    const headers = {
        'x-api-key': apiKey,
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${objectId}`
    };

    const updateFavoriteCards = async (User_ID, cardName, isFavorite) => {
        try {
            const response = await axios.post(
                `${process.env.REACT_APP_BACKEND_URL}/card/updateCardFavourite`,
                { User_ID, card_name: cardName, is_favourite: isFavorite },
                {
                    headers: headers
                }
            );
            console.log('Updated favorite card:', response.data);
        } catch (error) {
            console.error('Error updating favorite card:', error.response.data.message);
        }
    };

    const handleFavoriteClick = async (card) => {
        const isFavorite = favoriteCards.includes(card);
        // Update the favorite cards state
        setFavoriteCards((prevFavorites) => {
            if (prevFavorites.includes(card)) {
                // If the card is already in favorites, remove it
                return prevFavorites.filter(favCard => favCard !== card);
            } else {
                // Otherwise, add it to the favorites
                return [...prevFavorites, card];
            }
        });

        const User_ID = objectId.trim();
        await updateFavoriteCards(User_ID, card, !isFavorite); // dont change the logic of isFavourite
    };

    const getFontWeight = (style) => {
        switch (style) {
            case 'Light':
                return 300; // Font weight for Light
            case 'Regular':
                return 500; // Font weight for Regular
            case 'Medium':
                return 600; // Font weight for Medium
            case 'Semi Bold':
                return 700; // Font weight for Semi Bold
            case 'Bold':
                return 800; // Font weight for Bold
            default:
                return 'normal'; // Default font weight
        }
    };

    const [dialogs, setDialogs] = useState({
        Personal: false,
        Professional: false,
        Student: false,
        GenZ: false
    });

    const handleOpenDialog = (type) => {
        setDialogs((prevDialogs) => ({
            ...prevDialogs,
            [type]: true
        }));
    };

    const handleCloseDialog = (type) => {
        setDialogs((prevDialogs) => ({
            ...prevDialogs,
            [type]: false
        }));
    };

    const [sharePops, setSharePops] = useState({
        Personal: false,
        Professional: false,
        Student: false,
        GenZ: false
    });

    const handleShareClick = (type) => {
        setSharePops((prevDialogs) => ({
            ...prevDialogs,
            [type]: true
        }));
    };

    const handleShareClose = (type) => {
        setSharePops((prevDialogs) => ({
            ...prevDialogs,
            [type]: false
        }));
    };


    const [firstName, lastName] = userDetails.name.split(' ');
    //based on ncard name only saving and Fetching

    const createLayoutProps = (cardType) => {
        // console.log("ACTUALLY CARDDETAILS", cardDetailsAll);
        const CardDetailsFilterByName = cardDetailsAll?.find((state) => state?.CardName === cardType);
        const CardDeailsForStyles = cardStylesAll?.find((state) => state?.CardName === cardType);
        const CardContacts = cardContactsAll?.find((state) => state?.CardName === cardType);
        const CardWebsite = cardSocialLinkWebsites?.find((state) => (state?.CardName === cardType && state?.info_key === "website" && state?.is_visible)) || undefined;

        const details = CardDetailsFilterByName;
        // console.log("Card Details", details);
        const styles = CardDeailsForStyles;
        return {
            profilePicture: details?.profile_pic || DefaultProfileBg,
            companyLogo: details?.logo || DefaultProfileBg,
            cardType,
            prefix: details?.prefix || '',
            suffix: details?.suffix || '',
            firstName: details?.firstName || '',
            lastName: details?.lastName || '',
            companyName: details?.company || '',
            designation: details?.designation || '',
            title: details?.title || '',
            colorPrimary: styles?.colorPrimary,
            colorSecondary: styles?.colorSecondary,
            colorTitle: styles?.colorTitle,
            bgColor: styles?.bgColor || "#ffff",
            layoutColor: styles?.colorLayout || "#0044C6",
            labelColor: '#ffffff',
            style: styles?.style || "Lato",

            phoneNo: userDetails.phone,
            emailId: userDetails.email,
            isVerified: details?.isVerified || "false",
            website: CardWebsite,
            address: [CardContacts?.city, CardContacts?.country].filter(Boolean), // Filters out any `null` or `undefined`

            //To variate at the end
            quantity: quantity,
            CardStylesofCard: styles,
            sharePops: sharePops,
            cardDetailsofCard: details,
            handleFavoriteClick: handleFavoriteClick,
            userDetails: userDetails,
            ContactStylesofCard: ContactStylesForGenZ,
            dialogs: dialogs,
            handleCloseDialog: handleCloseDialog,
            handleShareClose: handleShareClose,
            getFontWeight: getFontWeight,
            handleOpenDialog: handleOpenDialog,
            handleShareClick: handleShareClick
        };
    };

    // const layoutStyleAll = (cardType) => {
    //     const currentLayout = cardStylesAll.find((card) => card.CardName === cardType)
    //     console.log("currentLayout:", currentLayout.layoutStyle);
    //     return currentLayout.layoutStyle;
    //     // console.log(`CARD STYLES for ${cardType}`, cardStylesAll);
    //     // if (cardType === "Customize_Personal" || cardType === "Personal") {
    //     //     return cardStylesAll?.[cardType]?.layoutStyle || '2';
    //     // }
    //     // return cardStylesAll?.[cardType]?.layoutStyle || '1'; // Dynamically access cardType
    // };

    const layoutStyleAll = (cardType) => {
        const currentLayout = cardStylesAll.find((card) => card.CardName === cardType);

        if (!currentLayout) {
            console.warn(`No layout found for cardType: ${cardType}`);
            return null; // Return a default value or null to indicate no layout was found
        }

        // console.log("currentLayout:", currentLayout.layoutStyle);
        return currentLayout.layoutStyle;
    };


    let hasRenderedCard = false;

    // Determine if any card will be rendered
    // console.log("ALL CARDS", AllCards);
    const renderedCards = AllCards
        ?.filter(card => card.card_type === 'Customize_Professional' || card.card_type === "Professional")
        ?.map(card => {
            // { console.log("CURRENT CARDNAME:", card.card_name) }
            const layoutStyle = layoutStyleAll(card.card_name);
            // console.log(`LayoutStyle ${card.card_type}`, layoutStyle);
            if (card.card_type === 'Customize_Professional' || card.card_type === "Professional") {
                if (['hr2', 'hr1', 'ca1', 'ca2', 'bk1', 'bk2', 'fl1', 'fl2', 'cs1', 'cs2', 'it1', 'it2', 'adv1', 'adv2', 'dr1', 'dr2'].includes(layoutStyle)) {
                    hasRenderedCard = true;
                    return (
                        <div className='BusinessCard_Size me-3' key={card.card_name}>
                            {AllCardLayouts(layoutStyle, createLayoutProps(card.card_name), card.card_name)}
                        </div>
                    );
                }
            }
            return null;
        });




    return (
        <>
            <div className={`container-card-display p-4 ${(renderedCards?.length === 0) ? "justify-content-center" : "justify-content-start"} `}>
                {loading ? (
                    <AllBusinessCardSkeleton />
                ) : (
                    <div className="items-container-card">
                        {/* If there are rendered cards, show them */}
                        {renderedCards.length > 0 ? (
                            renderedCards
                        ) : (
                            // If renderedCards is empty, show the "No Favourites" message
                            hasRenderedCard && (
                                <div className="items-container-card-Create" >
                                    <div className='no-fav-cards d-flex flex-column align-items-center justify-content-center'>
                                        <div className='flex-center'>
                                            <img src={Nofavourites} alt="No Favourites" />
                                        </div>
                                        <h6 className='heading-fav text-center mt-2 mb-0'>There are no Business cards in your Cards list</h6>
                                        <p className='heading-fav-content text-center m-0'>Visit the Cards section to create your Business cards</p>
                                        <Link to="/cards">
                                            <button className='mt-2 fav-button'>Create Business Card</button>
                                        </Link>
                                    </div>
                                </div>
                            )
                        )}
                    </div>
                )}

                <Box className="floating-dropdown-contacts" sx={{ position: 'relative', zIndex: 1, height: '100vh' }} >
                    <Link>
                        <Fab color="primary" aria-label="add" sx={{ position: 'fixed', bottom: 50, right: 50 }} onClick={handleCreateNewCard}>
                            <AddIcon />
                        </Fab>
                    </Link>
                </Box>


                {chooseCategory &&
                    <>
                        <>
                            <div className="lightbox-overlay">
                                <div className="lightbox-content">
                                    <>
                                        <div className='d-flex align-items-center justify-content-between'>
                                            <div className='d-flex align-items-center'>
                                                <IconButton onClick={() => { setchooseCategory(false); setOpenLightBoxForCategory(true); }}>
                                                    <ArrowBackIcon />
                                                </IconButton>
                                                <h6 className='heading-fav text-left mb-0 ms-1'>
                                                    Choose Category</h6>
                                            </div>
                                            {/* <button style={{ cursor: 'pointer' }} className="lightbox-close2" onClick={handleCloseVerifiedDialog}>×</button> */}
                                            <IconButton onClick={handleCloseVerifiedDialog} sx={{ margin: 0, padding: 0 }}>
                                                <CloseRoundedIcon />
                                            </IconButton>
                                        </div>

                                        <div className="mt-2 selectedOptions d-flex align-items-center justify-content-around">
                                            <div className={`mx-2 CardCategory flex-center flex-column `}
                                                onClick={() => { setChooseCustomizeCategory(true); setchooseCategory(false) }}>
                                                <div className="icon-outside-new"><PersonalCardIcon /></div>
                                                <div className="myself">Customize</div>
                                            </div>
                                            {/* {(!cards.includes('Personal')) && (
                                                            <div className={`mx-2 CardCategory flex-center flex-column ${NewCardType == 'Personal' ? 'selected' : ''}`}
                                                                onClick={() => handleCardTypeClick('Personal')}>
                                                                <div className="icon-outside-new"><ProfessionalIcon /></div>
                                                                <div className="myself">Personal</div>
                                                            </div>
                                                        )} */}
                                            {(!cards.includes('Professional')) && (
                                                <div className={`mx-2 CardCategory flex-center flex-column ${NewCardType == 'Professional' ? 'selected' : ''}`}
                                                    onClick={() => handleCardTypeClick('Professional')}>
                                                    <div className="icon-outside-new"><ProfessionalIcon /></div>
                                                    <div className="myself">Professional</div>
                                                </div>
                                            )}
                                            {(!cards.includes('Student')) && (
                                                <div className={`mx-2 CardCategory flex-center flex-column ${NewCardType === 'Student' ? 'selected' : ''}`}
                                                    onClick={() => handleCardTypeClick('Student')}>
                                                    <div className="icon-outside-new"><StudentIcon /></div>
                                                    <div className="myself">Student</div>
                                                </div>
                                            )}
                                            {/* {(!cards.includes('GenZ')) && (
                                                                <div className={`mx-2 CardCategory flex-center flex-column ${NewCardType === 'GenZ' ? 'selected' : ''}`}
                                                                    onClick={() => handleCardTypeClick('GenZ')}>
                                                                    <div className="icon-outside-new"><GenzIcon /></div>
                                                                    <div className="myself">GenZ</div>
                                                                </div>
                                                            )} */}
                                        </div>
                                    </>
                                </div>
                            </div>
                        </>
                    </>
                }

                {chooseCustomizeCategory &&
                    <>
                        <div className="lightbox-overlay">
                            <div className="lightbox-content">
                                <>
                                    <div className='d-flex align-items-center justify-content-between'>
                                        <div className='d-flex align-items-center'>
                                            <IconButton onClick={() => { setchooseCategory(true); setChooseCustomizeCategory(false); }}>
                                                <ArrowBackIcon />
                                            </IconButton>
                                            <h6 className='heading-fav text-left mb-0 ms-1'>
                                                Choose Category for Customization</h6>
                                        </div>
                                        <IconButton onClick={handleCloseVerifiedDialog} sx={{ margin: 0, padding: 0 }}>
                                            <CloseRoundedIcon />
                                        </IconButton>
                                    </div>

                                    <div className="mt-2 selectedOptions d-flex align-items-center justify-content-around">
                                        {cards.includes("Personal") && (
                                            <div className={`mx-2 CardCategory flex-center flex-column ${NewCardType == 'Personal' ? 'selected' : ''}`}
                                                onClick={() => handleCardTypeClick('Customize_Personal')}>
                                                <div className="icon-outside-new"><PersonalCardIcon /></div>
                                                <div className="myself">Personal</div>
                                            </div>
                                        )}
                                        {cards.includes("Professional") && (
                                            <div className={`mx-2 CardCategory flex-center flex-column ${NewCardType == 'Customize_Professional' ? 'selected' : ''}`}
                                                onClick={() => handleCardTypeClick('Customize_Professional')}>
                                                <div className="icon-outside-new"><ProfessionalIcon /></div>
                                                <div className="myself">Professional</div>
                                            </div>
                                        )}
                                        {cards.includes("Student") && (
                                            <div className={`mx-2 CardCategory flex-center flex-column ${NewCardType === 'Customize_Student' ? 'selected' : ''}`}
                                                onClick={() => handleCardTypeClick('Customize_Student')}>
                                                <div className="icon-outside-new"><StudentIcon /></div>
                                                <div className="myself">Student</div>
                                            </div>
                                        )}
                                        {/* <div className={`mx-2 CardCategory flex-center flex-column ${NewCardType === 'Customize_GenZ' ? 'selected' : ''}`}
                                                                            onClick={() => handleCardTypeClick('Customize_GenZ')}>
                                                                            <div className="icon-outside-new"><GenzIcon /></div>
                                                                            <div className="myself">GenZ</div>
                                                                        </div> */}
                                    </div>
                                </>
                            </div>
                        </div>
                    </>
                }

            </div>
        </>
    );
}

export default AllBusinessCard;